import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import InputField from '../InputField';

import IconEyeOpen from '../../icons/eye-open.svg';
import IconEyeClose from '../../icons/eye-close.svg';

import styles from './PasswordField.styl';

const cx = classNames.bind(styles);

class PasswordField extends PureComponent {
  static defaultProps = {
    className: '',
  };

  static propTypes = {
    className: PropTypes.string,
  };

  state = {
    showed: false,
  };

  toggle = () => {
    this.setState({ showed: !this.state.showed });
  };

  render() {
    const { showed } = this.state;
    const { className, ...inputProps } = this.props;

    return (
      <div className={cx('PasswordField', className)}>
        <InputField type={showed ? 'text' : 'password'} name="password" {...inputProps} />
        <div className={cx('PasswordField__icon')} onClick={this.toggle}>
          {showed ? (
            <IconEyeOpen width={24} height={24} />
          ) : (
            <IconEyeClose width={24} height={24} />
          )}
        </div>
      </div>
    );
  }
}

export default PasswordField;
